import type { WorkCategoryAllSupported } from '@atlassian/jira-servicedesk-work-category/src/controllers/use-work-category-all-supported/types.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_ISSUE_TYPES } from '../constants.tsx';

type Data = Record<
	WorkCategoryAllSupported,
	{
		issueTypes: {
			id: string;
			description: string;
			name: string;
			iconUrl: string;
			subtask: boolean;
		}[];
	}
>;

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-issue-types", jiraSpaEntry: "async-resource-servicedesk-issue-types" */ './get-data'
	);

export const servicedeskIssueTypesResource = createResource<Data | null>({
	type: RESOURCE_TYPE_SERVICEDESK_ISSUE_TYPES,
	getKey: ({ match: { params } }) => params.projectKey || '',
	getDataLoader,
});
